let registration: ServiceWorkerRegistration | null = null

export function setServiceWorkerRegistration(next: ServiceWorkerRegistration): void {
  registration = next
}

/** Returns true when an update check ran. */
export async function checkForUpdate(): Promise<boolean> {
  const reg = registration ?? (await navigator.serviceWorker?.getRegistration?.()) ?? null
  if (!reg) return false
  await reg.update()
  return true
}
